import React from 'react';
import { useSelector } from 'react-redux';

import LabelElementPillsContainer from '../../../labels/LabelElementPillsContainer';
import { selectLabelsByIds } from '../../../labels/labelSelectors';
import { length } from '../../../../../common/utils/immutableHelper';
import { TaskLabelData } from '../taskPillsTypes';

type TaskLabelPillsProps = TaskLabelData & {
    permissions: number;
    taskListElementId?: string;
};

const TaskLabelPills: React.FC<TaskLabelPillsProps> = ({
    labelIds,
    element,
    filterQuery,
    permissions,
    taskListElementId,
    labelScopeId,
}) => {
    const elementLabels = useSelector(selectLabelsByIds(labelIds));
    const labelCount = length(elementLabels);

    if (!labelCount || !elementLabels) return null;

    return (
        <LabelElementPillsContainer
            labels={elementLabels}
            size="xs"
            element={element}
            selectedElementId={taskListElementId}
            filterQuery={filterQuery}
            permissions={permissions}
            labelScopeId={labelScopeId}
        />
    );
};

export default TaskLabelPills;
